<app-dropdown *ngIf="unfilteredData.series[0] && unfilteredData.series[0].length > 1" [items]="dropdownItems" [stringAttr]="'text'" [stringAttrIntl]="true"
[selectedItem]="selectedTimeSpan" (onItemSelected)="timeSpanChanged($event)"
[right]="true">
</app-dropdown>

<div [class.d-none]="unfilteredData.series[0] && unfilteredData.series[0].length <= 1">
<canvas id="myChart" width="700" height="250"></canvas>
</div>
